import { gql } from 'graphql-request';

export const PRINCIPAL_FRAGMENT = gql`
    fragment PrincipalFields on Principal {
        id
        companyId
        username
        name
        creationDate
        imageUrl
        isEnabled
        departmentId
        pricingAuthority
    authorities
        authProviders
        registrationState
        registrationChannel
        isFromWebhotelier
        accessControl {
            companyHotelId
						hotelName
            domainAuthorities {
                authority
                domain
            }
        }
    }
`